import { Schema } from "effect";

/** Shared by candidate composition and target refresh; diagnostics stay local. */
export const CandidateTargetRef = /* @__PURE__ */ (() => Schema.String.check(
  Schema.isPattern(/^[A-Za-z0-9][A-Za-z0-9._/-]{0,127}$/),
  Schema.makeFilter(value => !value.includes("//") && !value.split("/").some(part => part === "." || part === ".."))
))();

/** Unbranded integer bounds shared by development revisions and timestamps. */
export const PositiveInteger = /* @__PURE__ */ (() => Schema.Int.check(Schema.isGreaterThanOrEqualTo(1)))();
export const NonNegativeInteger = /* @__PURE__ */ (() => Schema.Int.check(Schema.isGreaterThanOrEqualTo(0)))();
